export default function StocksConfigurationProduitsNiveauxConfiguration($translatePartialLoaderProvider) {
	$translatePartialLoaderProvider.addPart('stocks.configuration.produits.niveaux');
}

StocksConfigurationProduitsNiveauxConfiguration.$inject = ['$translatePartialLoaderProvider'];
